import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from "react";

const UserListTable = ({
  user,
  page,
  sort,
  setSort,
  selected,
  setSelected,
  setIsUserModalOpen,
  setIsUserNameValid
}) => {
  const { t } = useTranslation()

  const onSelect = (item) => {
    setSelected(item);
    setIsUserModalOpen(false);
    setIsUserNameValid('')
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative rounded-lg border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>
              <th
                scope='col'
                className='py-3 px-6'
              >
                <div className='flex'>
                  <span>{t('O_NAME')} </span>
                </div>
              </th>

              <th
                scope='col'
                className='py-3 px-6'
              >
                <div className='flex'>
                  <span>{t('O_EMAIL_ADDRESS')} </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_USERNAME')}
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_COUNTRY_CODE')}
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_MOBILE')}
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {user &&
              user?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-4 px-6 border-r'>{item?.name} </td>
                  <td className='py-4 px-6 border-r'>{item?.email}</td>
                  <td className='py-4 px-6 border-r'>{item?.username}</td>
                  <td className='py-4 px-6 border-r text-right'>
                    +{item?.country_code}{' '}
                  </td>
                  <td className='py-4 px-6 border-r text-right'>
                    {item?.mobile}{' '}
                  </td>
                  {
                    item?._id == selected?._id ? (
                      <td className='py-4 px-6 border-r cursor-pointer text-green-500' onClick={() => onSelect(item)}>Selected</td>
                    ) : (
                      <td className='py-4 px-6 border-r cursor-pointer text-blue-700' onClick={() => onSelect(item)}>Select</td>
                    )
                  }
                </tr>
              ))}
            {isEmpty(user)
              ? (
                <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6' colSpan={12}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )
              : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default UserListTable
